import { useEffect, useState } from "react"
import {
  ref,
  query,
  orderByChild,
  equalTo,
  startAt,
  onValue,
} from "firebase/database"
import { rtdb } from "../../Firebase/config"

const useFetchDriverOrders = (collectionName, name) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  let unsubscribe = null

  const getDriverOrders = () => {
    setLoading(true)

    try {
      if (!name) {
        setLoading(false)
        return
      }

      const last15Hours = Date.now() - 15 * 60 * 60 * 1000
      const ordersRef = ref(rtdb, collectionName)

      const driverOrdersQuery = query(
        ordersRef,
        orderByChild("assignedDriver"),
        equalTo(name)
      )

      unsubscribe = onValue(driverOrdersQuery, (snapshot) => {
        if (snapshot.exists()) {
          const fetchedData = Object.entries(snapshot.val())
            .map(([id, order]) => ({
              id,
              ...order,
            }))
            .filter((order) => order.createdAt._seconds * 1000 >= last15Hours)
            .sort((a, b) => b.createdAt._seconds - a.createdAt._seconds)

          setData(fetchedData)
        } else {
          setData([])
        }

        setLoading(false)
      })
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        getDriverOrders()
      } else if (unsubscribe) {
        unsubscribe()
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange)
    getDriverOrders() // Initial fetch

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange)
      if (unsubscribe) unsubscribe() // Cleanup on unmount
    }
  }, [collectionName, name])

  return { data, loading }
}

export default useFetchDriverOrders
